import { useCallback } from "react";

import type { DiscountLongTermInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { DISCOUNT_LONG_TERM_FOR_LONG_TERM_STAY_UPDATE_MUTATION } from "./schema";

type Props = {
	onResetViewModel: () => void;
};

export const useDiscountLongTermUpdateMutation = ({ onResetViewModel }: Props) => {
	const { mutationFunc } = useCustomMutation(DISCOUNT_LONG_TERM_FOR_LONG_TERM_STAY_UPDATE_MUTATION);
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const onUpdateDiscountLongTerm = useCallback(
		async (input: DiscountLongTermInput) => {
			showLoadingScreenCallback();
			const { errors } = await mutationFunc({
				variables: { input },
			}).finally(() => {
				hideLoadingScreenCallback();
			});

			if (!errors) {
				notifyUserEventInfo({
					variant: "default",
					title: "連泊ディスカウントを更新しました",
				});
				onResetViewModel();
			}
		},
		[hideLoadingScreenCallback, mutationFunc, onResetViewModel, showLoadingScreenCallback],
	);

	return {
		onUpdateDiscountLongTerm,
	};
};
